module.exports = __webpack_public_path__ + "assets/a4b7bd9e63362a6c3882dbe1d155a585.png";